module.exports = __webpack_public_path__ + "img/upper_pocket_length.bb669d2c.png";